module.exports = __webpack_public_path__ + "img/afrikan-heroes-grey.ac234c90.png";